import React from "react";
import { Row, Col, Typography, Card } from "antd";
import { checkIncomingDataType } from "../AllOrgActivities/helper";
const { Text } = Typography;

export const AccCloneActivity = ({ data }) => {
  const settings = data[0]?.new_value || [];
  const cardTitle = (
    <Text strong style={{ fontSize: "20px", color: "#111314", fontWeight: 600 }}>
      Cloned Account Settings
    </Text>
  );

  return (
    <Card title={cardTitle}>
      <Row gutter={[8, 8]}>
        {settings.map((label, index) => (
          <Col span={12} key={label}>
            <Text strong style={{ fontSize: "16px" }}>
              {`${index + 1}. `}
              {checkIncomingDataType(_.startCase(label))}
            </Text>
          </Col>
        ))}
      </Row>
    </Card>
  );
};